function downloadFile( url, fileName ) {
	const el = document.createElement( 'a' );
	el.style.display = 'none';
	el.setAttribute( 'target', '_self' );
	fileName && el.setAttribute( 'download', fileName );
	el.href = url;
	document.body.appendChild( el );
	el.click();
	document.body.removeChild( el );
}

export default downloadFile;
